import React from "react";
import useTitle from "../../hooks/UseTittle";
import { motion } from "framer-motion";

import laptop_world from "../../assects/images/project/laptop_world.png";
import justica from "../../assects/images/project/justica.png";
import quizzee from "../../assects/images/project/quizzee.png";
import techtoolbox from "../../assects/images/project/techtoolbox.png";
import rateuz from "../../assects/images/project/rateuz.jpeg";
import rateuzDashboard from "../../assects/images/project/rateuzDashboard.jpeg";
import bookfiiDashboard from "../../assects/images/project/bookfiiDashboard.jpeg";

import react from "../../assects/icons/skills/react.svg";
import redux from "../../assects/icons/skills/redux.svg";
import next from "../../assects/icons/skills/next.svg";
import js from "../../assects/icons/skills/js.svg";
import ts from "../../assects/icons/skills/ts.svg";
import html from "../../assects/icons/skills/html.svg";
import api from "../../assects/icons/skills/api.svg";
import mongodb from "../../assects/icons/skills/mongodb.png";
import firebase from "../../assects/icons/skills/firebase.svg";
import figma from "../../assects/icons/skills/figma.svg";
import css from "../../assects/icons/skills/css.svg";
import scss from "../../assects/icons/skills/scss.svg";
import mui from "../../assects/icons/skills/mui.svg";
import styled from "../../assects/icons/skills/styled.png";
import tailwind from "../../assects/icons/skills/tailwind.svg";
import bootstrap from "../../assects/icons/skills/Bootstrap.png";
import wordpress from "../../assects/icons/skills/wordpress.svg";
import git from "../../assects/icons/skills/git.svg";
import node from "../../assects/icons/skills/node.png";
import Tooltip from "../Tooltip/Tooltio";

const Resume = () => {
  useTitle("Mofazzel | Blogs");

  const parentVariant = {
    hidden: {
      opacity: 0,
      x: 200,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.8,
        ease: [0, 0.71, 0.2, 1.01],
        delayChildren: 0.4,
        staggerChildren: 0.2,
        damping: 30,
      },
    },
  };

  const item = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        damping: 100,
      },
    },
  };

  const projects = [
    {
      img: laptop_world,
      date: "17 April",
      describe: "Reselling Website",
      title: "Laptop World",
      bgColor: "#fff4f4",
      address: "https://second-hand-products.web.app",
      tech: [
        {
          icon: tailwind,
          name: "Tailwind",
        },
        {
          icon: react,
          name: "React",
        },
        {
          icon: mongodb,
          name: "Mongo DB",
        },
        {
          icon: firebase,
          name: "Firebase",
        },
      ],
    },
    {
      img: justica,
      date: "17 April",
      describe: "Inspiration",
      title: "Justica",
      bgColor: "#fcf4ff",
      address: "https://justica-law-client.web.app/",
      tech: [
        {
          icon: tailwind,
          name: "Tailwind",
        },
        {
          icon: react,
          name: "React",
        },
        {
          icon: mongodb,
          name: "Mongo DB",
        },
        {
          icon: firebase,
          name: "Firebase",
        },
      ],
    },

    {
      img: quizzee,
      date: "17 April",
      describe: "MCQ Quiz taking Website",
      title: "Quizzee",
      bgColor: "#fff4f4",
      address: "https://sweet-cranachan-ca0098.netlify.app/",
      tech: [
        {
          icon: html,
          name: "HTML",
        },
        {
          icon: css,
          name: "CSS",
        },
        {
          icon: tailwind,
          name: "Tailwind",
        },
        {
          icon: js,
          name: "JavaScript",
        },
      ],
    },
    {
      img: techtoolbox,
      date: "17 April",
      describe: "Simple News Site",
      title: "Tech Toolbox",
      bgColor: "#fff4f4",
      address: "https://steady-beignet-46beb0.netlify.app/",
      tech: [
        {
          icon: html,
          name: "HTML",
        },
        {
          icon: css,
          name: "CSS",
        },
        {
          icon: tailwind,
          name: "Tailwind",
        },
        {
          icon: js,
          name: "JavaScript",
        },
      ],
    },
    {
      img: rateuz,
      date: "17 April",
      describe: "Landing Page",
      title: "rateuz",
      bgColor: "#fff4f4",
      address: "https://moofazzel.github.io/rateuz/",
      tech: [
        {
          icon: html,
          name: "HTML",
        },
        {
          icon: css,
          name: "CSS",
        },
        {
          icon: bootstrap,
          name: "Bootstrap",
        },
      ],
    },
    {
      img: rateuzDashboard,
      date: "17 April",
      describe: "Rateuz Dashboard",
      title: "Dashboard",
      bgColor: "#fff4f4",
      address: "https://moofazzel.github.io/Rateuz-Dashboard/",
      tech: [
        {
          icon: html,
          name: "HTML",
        },
        {
          icon: css,
          name: "CSS",
        },
        {
          icon: bootstrap,
          name: "Bootstrap",
        },
        {
          icon: js,
          name: "JavaScript",
        },
      ],
    },
    {
      img: bookfiiDashboard,
      date: "17 April",
      describe: "Bookfii Dashboard",
      title: "Dashboard",
      bgColor: "#fff4f4",
      address: "https://moofazzel.github.io/Dashboard-Bookfii/index.html",
      tech: [
        {
          icon: html,
          name: "HTML",
        },
        {
          icon: css,
          name: "CSS",
        },
        {
          icon: bootstrap,
          name: "Bootstrap",
        },
        {
          icon: js,
          name: "JavaScript",
        },
      ],
    },
  ];

  return (
    <>
      <motion.div
        variants={parentVariant}
        initial="hidden"
        animate="visible"
        id="blogs"
        className="bg-b-drop"
      >
        <div className="container px-4 sm:px-5 md:px-10 lg:px-[60px]">
          <div className="py-12">
            <h2 className="after-effect after:left-44 lg:mt-0 ">Projects</h2>
            <div className="grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 mt-[30px] grid gap-x-6 gap-y-7 mb-6">
              {/* <!-- blog items one start --> */}

              {projects.map((blog, i) => (
                <motion.a
                  href={blog.address}
                  target="_blank"
                  rel="noopener"
                  variants={item}
                  key={i}
                  className={`flex flex-col justify-between h-full p-5 mb-3 border-4 rounded-xl  bg-[${blog.bgColor}] border shadow-sm hover:shadow-2xl hover:scale-150 transition-all duration-500`}
                >
                  <div>
                    <div className="overflow-hidden rounded-lg">
                      <img
                        className="rounded-lg w-full cursor-pointer transition-all duration-500
                        .ease-in-out hover:scale-105 hover:rotate-3"
                        src={blog.img}
                        target="_blank"
                        title="View full website"
                        alt="project"
                      />
                    </div>
                    <h3 className="text-lg font-semibold duration-300 transition cursor-pointer mt-3 pr-4 hover:text-[#FA5252]">
                      {blog.title}
                    </h3>
                    <p className="text-gray-500 font-normal">{blog.describe}</p>
                  </div>

                  <hr className="mt-auto my-4 bg-slate-300 h-[2px] -mx-3 rounded-full shadow-2xl" />

                  <div className="mt-1 flex gap-4">
                    {blog.tech.map((t) => {
                      return (
                        <Tooltip content={t.name} direction="top">
                          <img
                            className="w-6 h-6 hover:scale-125 transition-all"
                            src={t.icon}
                            alt="#"
                          />
                        </Tooltip>
                      );
                    })}
                  </div>
                </motion.a>
              ))}

              {/* <!-- blog items one end --> */}
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Resume;
